export const connectedStrikers = [
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Alice", email: "alice@example.com" },
  { username: "Aaron", email: "aaron@example.com" },
  { username: "Ethan", email: "ethan@example.com" },
  { username: "Ella", email: "ella@example.com" },
  { username: "Frank", email: "frank@example.com" },
  { username: "Fiona", email: "fiona@example.com" },
  { username: "George", email: "george@example.com" },
  { username: "Grace", email: "grace@example.com" },
  { username: "Harry", email: "harry@example.com" },
  { username: "Hannah", email: "hannah@example.com" },
  { username: "Ian", email: "ian@example.com" },
  { username: "Isla", email: "isla@example.com" },
  { username: "Jack", email: "jack@example.com" },
  { username: "Thomas", email: "thomas@example.com" },
  { username: "Tina", email: "tina@example.com" },
  { username: "Umar", email: "umar@example.com" },
  { username: "Uma", email: "uma@example.com" },
];
export const pendingStrikers = [
  { username: "Grace", email: "grace@example.com" },
  { username: "Harry", email: "harry@example.com" },
  { username: "Hannah", email: "hannah@example.com" },
  { username: "Ian", email: "ian@example.com" },
  { username: "Isla", email: "isla@example.com" },
  { username: "Jack", email: "jack@example.com" },
  { username: "Thomas", email: "thomas@example.com" },
  { username: "Tina", email: "tina@example.com" },
  { username: "Umar", email: "umar@example.com" },
  { username: "Uma", email: "uma@example.com" },
];
export const localAlphabets = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];

export const tabsArr = [
  {
    title: "Connected Strikers",
    key: "connected",
  },
  {
    title: "Pending Requests",
    key: "pending",
  },
];

export const statusTagsColors = {
  connected: "#58BF73",
  pending: "#F4BD00",
  invited: "#8ACC2D",
  not_connected: "#687385",
};
export const statusTagslabels = {
  connected: "Connected",
  pending: "Pending",
  invited: "Invited",
  not_connected: "Not Connected",
};
